module.exports = __webpack_public_path__ + "img/branch_image.d6c27f6e.png";